import { imageUrl } from "@a2z/ui/media/image-url";
import { MEDIA_BASE_URL } from "@/lib/media-base";

const CARD_WIDTH = 240;

/**
 * Build a CF Image Transformations URL for an order item's card thumbnail.
 * Backend returns the raw object key + bg-removal preference; the seller
 * portal picks the size it needs and renders.
 */
export function getOrderItemImageUrl(item: {
  cardObjectKey: string | null;
  cardUseBgRemoved: boolean;
}): string | null {
  if (!item.cardObjectKey) {
    return null;
  }
  return imageUrl(
    item.cardObjectKey,
    {
      width: CARD_WIDTH,
      format: "auto",
      removeBackground: item.cardUseBgRemoved === true,
    },
    { baseUrl: MEDIA_BASE_URL },
  );
}
